
// SCRIPTS

import { CTMSHomePage } from './home/scripts/home.page'; export { CTMSHomePage };
import { CTMSSiteDetailsPage } from './sites/scripts/site-details.page'; export { CTMSSiteDetailsPage };
import { CTMSUserDetailsPage } from './settings/scripts/user-details.page'; export { CTMSUserDetailsPage };

// STYLES
import './ctms.scss';
import './contacts/components/contact-dialog.scss';
import './communications/components/communications-dialog.scss';
import './settings/components/user-dialog.scss';
import './settings/settings.scss';